import { useQuery } from "react-query";
import { AUTH_USER, GUEST_USER } from "../constants";
import { customerBusinessService } from "../services";

const getRewards = async (customer_id: number,location_id:number, my_rewards: number, past_rewards: number, discount_applied: number) => {
    const response = await customerBusinessService.getMyRewards()
    return response.data.data;
};

export default function useGetRewards(customer_id: number,location_id:number, my_rewards: number, past_rewards: number, discount_applied: number, userType: string = AUTH_USER) {

    return useQuery<any>(
        ["myRewards", customer_id],
        () => getRewards(customer_id,location_id, my_rewards, past_rewards, discount_applied),
        {
            retry: false,
            enabled: userType !== GUEST_USER && !!customer_id
        }
    );
}
